import Api from './coreapi';
export default {
    getStockinFromVendor(filter){
        return new Promise((resolve) => {
            Api.request().post('get-stock-in-by-vendor', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    getInvoiceLineByStockin(filter){
        return new Promise((resolve) => {
            Api.request().post('generate-invoice-lines', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    findStockin(filter){
        return new Promise((resolve) => {
            Api.request().post('stockin/find', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    approveStockin(filter){
        return new Promise((resolve) => {
            Api.request().post('stockin/approve', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    }
}